export const badlaOpions = [
  { label: "GOLD", value: "GOLD" },
  { label: "SILVER", value: "SILVER" },
  { label: "COPPER", value: "COPPER" },
  { label: "CRUDE", value: "CRUDE" },
  { label: "NATURAL GAS", value: "GAS" },
];

export const historyFilterTypeOptions = [
  { label: "Day wise", value: true },
  { label: "Minute wise", value: false },
];

export const orderTypeOptions = [
  { label: "sell", value: "sell" },
  { label: "buy", value: "buy" },
];

export const brokerageTypeOptions = [{ label: "lot", value: "lot" }];
